<div class="spinner-container">
    <div class="spinner-component">
        <it-spinner [active]="true" />
    </div>
</div>